import { AngularMaterialModule } from '../../angular-material.module';
import { CarrierPipe } from '../../../history/pipes/carrier.pipe';
import { CommonModule } from '@angular/common';
import { CountryService } from '../../services/country/country.service';
import { DataTablesModule } from 'angular-datatables';
import { DialogModule } from '../../services/dialog/dialog.module';
import { ElementBlockerModule } from '../element-blocker/element-blocker.module';
import { ErrorHandlerService } from '../../services/error-handler/error-handler.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SafeStringModule } from '../../pipes/safe-string/safe-string.module';
import { ShipDetailsComponent } from './ship-details.component';
import { ShipDetailsPrintDialogComponent } from './ship-details-print-dialog/ship-details-print-dialog.component';
import { ShipLabelModule } from '../ship-label/ship-label.module';
import { ShipmentHistoryService } from '../../../history/services/shipment-history.service';
import { ShipmentPipesModule } from '../../pipes/shipment/shipment-pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { UserCurrencyModule } from '../../pipes/user-currency/user-currency.module';
import { UserService } from '../../services/user/user.service';
import { UserWeightModule } from '../../pipes/user-weight/user-weight.module';
import { ShipConfigService } from '../../../ship/services/ship-config.service';
import { AddressBookService } from '../../../address-book/services/address-book.service';
import { DeliveryDefenseScoreSummaryModule } from '../delivery-defense-score-summary/delivery-defense-score-summary.module';

@NgModule({
    imports: [
        AngularMaterialModule,
        CommonModule,
        DataTablesModule,
        DialogModule,
        ElementBlockerModule,
        ReactiveFormsModule,
        SafeStringModule,
        ShipLabelModule,
        ShipmentPipesModule,
        TranslateModule,
        UserCurrencyModule,
        UserWeightModule,
        DeliveryDefenseScoreSummaryModule,
    ],
    declarations: [
        ShipDetailsComponent,
        ShipDetailsPrintDialogComponent,
    ],
    providers: [
        AddressBookService,
        CarrierPipe,
        CountryService,
        ErrorHandlerService,
        ShipmentHistoryService,
        ShipConfigService,
        UserService,

        // These 2 providers are required or it will throw StaticInjectionError: NullInjectorError: No provider for MatDialogRef!
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: [] },
    ],
    exports: [
        ShipDetailsComponent,
        ShipDetailsPrintDialogComponent,
    ],
})
export class ShipDetailsModule {
}
